// Owner, 2026-09-28: the Platform Visibility boxes are three independent
// flags kept in one row per product. No box checked means every platform;
// the API reads an all-false row the same way.

const liveRows = (rows) =>
  Array.isArray(rows) ? rows.filter((row) => row && !row.isdeleted) : [];

export const readPlatformFlags = (rows) => {
  const live = liveRows(rows);
  return {
    isweb: live.some((row) => !!row.isweb),
    iskiosk: live.some((row) => !!row.iskiosk),
    ismobile: live.some((row) => !!row.ismobile),
  };
};

// Toggling a box changes only that flag. The form keeps a single row: the
// first live row's fields with the merged flags.
export const togglePlatformFlag = (rows, key, checked) => {
  const [first] = liveRows(rows);
  return [{ ...(first || {}), ...readPlatformFlags(rows), [key]: checked }];
};

// What to write when the product is saved: update its first row (or create
// one when a box is checked), and delete any extra rows so the saved choice
// is the only one.
export const planPlatformSave = (originalRows, currentRows, productId) => {
  const flags = readPlatformFlags(currentRows);
  const body = {
    isWeb: flags.isweb,
    isKiosk: flags.iskiosk,
    isMobile: flags.ismobile,
  };
  const [first, ...extra] = liveRows(originalRows);
  if (first) {
    return {
      update: { id: first.id, ...body },
      create: null,
      deleteIds: extra.map((row) => row.id),
    };
  }
  const anyChecked = flags.isweb || flags.iskiosk || flags.ismobile;
  return {
    update: null,
    create: anyChecked ? { productId, ...body } : null,
    deleteIds: [],
  };
};
